import { DarkModeRounded as DarkModeRoundedIcon, LightModeRounded as LightModeRoundedIcon } from '@mui/icons-material'
import { IconButton } from '@mui/material'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'

const ThemeToggle = () => {
  const { theme, setTheme } = useGlobalContext()

  return (
    <IconButton
      aria-label={theme === 'light' ? 'attiva la modalità scura' : 'attiva la modalità chiara'}
      onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
      color="primary"
    >
      {theme === 'light' && <DarkModeRoundedIcon fontSize="small" />}
      {theme === 'dark' && <LightModeRoundedIcon fontSize="small" />}
    </IconButton>
  )
}

export default ThemeToggle
